import { Container, Row } from "reactstrap";
import CustomSwitch from "./CustomSwitch";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormWidgetsTitle, SwitchTitle } from "../../../../../Constants/Constants";
import DisabledOutlineSwitch from './DisabledOutlineSwitch'
import IconUncheckedBorderSwitch from './IconUncheckedBorderSwitch'
import SwitchSizingIcons from './SwitchSizingIcons'
import VariationOfSwitches from './VariationOfSwitches'
import { Fragment } from "react/jsx-runtime";

const SwitchContainer = () => {
  return (
    <Fragment>
    <Breadcrumbs mainTitle={SwitchTitle} parent={FormWidgetsTitle}/>
      <Container fluid>
        <Row>
          <CustomSwitch />
          <IconUncheckedBorderSwitch />
          <DisabledOutlineSwitch />
          <VariationOfSwitches />
          <SwitchSizingIcons />
        </Row>
      </Container>
    </Fragment>
  );
};
export default SwitchContainer;
